Jelly.Interface =
{	
	// Lightbox element.
	Lightbox_Element: null,

	// TODO - I feel funky about this one.
	Global_Controls_Element: null,
	
	// TODO - ???
	Highlight_Parts: null,
	Highlight_Target_Namespace: null,

	// Bubbles
	Event_Protection: {},
	Event_Protection_Period: 50,
	
	// Maps
	Maps: {},
	
	// Windows
	Window_Index: 0,
	Window_Z_Index_Start: 11000,
	Menu_Z_Index_Start: 13000,
	Modal_Windows: [],
	Window_Buffer: 20,

	// Interstitial
	// TODO - this is only used for mobile right now
	Interstitial: null,

	// Modals
	Visible_Modal: null,

	// Menus
	Active_Menu_Reference: null,
	Base_Menu_Reference: null,
	Menu_Position_Offset: {Left: 1, Top: -5},
	Selected_Menu_Item: null,
	
	// Modality...
	// State
	Is_Locked: false,
	
	// TODO - more integrated listeners
	Refresh_Container_Listeners: [],
	Refresh_Listeners: [],
	
	// TODO - Inspector hack
	Inspect_Item: null 
};